import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import CustomSelectComp from "./CustomSelectComp";
import {
  getL2SheetProperty,
  getL1SheetProperty,
  setLevel2Properties,
} from "../../../WorkbookSlice";
import { useGetFiltersOptionsMutation } from "../../../dataApiSlice";
import { useSelector, useDispatch } from "react-redux";
import { getColourSchemeByID } from "../../../../../Colors/ColorPalettes";
import SelectBox from "../DropzoneComponents/FilterConfigCompComponents/SelectBox";
import { getSheetControls } from "../../../WorkbookControllingSlice";

export default function CustomColorControlerComp({
  customColorModal,
  setCustomColorModal,
  options,
  Sheetid,
  ControllerProps,
  dispatchItemToredux,
  handleColorChange,
  VizchartType,
  selectedValue: selectedField,
  handleValueChange,
  optionsArray,

  saveConditionalFormatting,
}) {
  const dispatch = useDispatch();
  const dataSourceID = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "dataSourceID")
  );
  const rowValue = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "rows")
  );
  const groupValue = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", "groupByFields")
  );
  console.log(groupValue[0]);
  console.log(optionsArray[0]);

  const uniqueColumns = useSelector(
    getSheetControls({ Sheetid, key: "uniqueColumnValues" })
  );

  const requirdValue = (VizchartType) => {
    switch (VizchartType) {
      case "piechart":
      case "areamap":
        return groupValue[0]?.columnName;
      case "linechart":
        return uniqueColumns[0].columnName;
      case "areachart":
      case "stackedbarchart":
        return uniqueColumns[0].columnName;
      case "stackedbarchartimage":
        return uniqueColumns[0].columnName;
      case "combochart":
        return uniqueColumns[0].columnName;
      case "radarchart":
      // return valueColumns[0].columnName;
      case "scatterchart":
        return rowValue[0]?.columnName;
      case "treechart":
        return groupValue[0]?.columnName;
      case "cordinatemap":
        return optionsArray[0].value;
      default:
        break;
    }
  };
  const columnName =
    (rowValue && rowValue.length > 0) ||
    (groupValue && groupValue.length > 0) ||
    (uniqueColumns && uniqueColumns.length > 0)
      ? requirdValue(VizchartType)
      : null;

  console.log(rowValue);
  console.log(groupValue);
  console.log(columnName);

  const [getFiltersOptions, { data, isError, error, isLoading, isSuccess }] =
    useGetFiltersOptionsMutation();

  // call api only piechart
  function allOptions() {
    switch (VizchartType) {
      case "piechart":
      case "areamap":
        return Object.values(data ?? {})[0]?.map((value) => value) ?? [];
      case "linechart":
        return uniqueColumns?.map((item) => item.columnName) ?? [];
      case "areachart":
        return uniqueColumns?.map((item) => item.columnName) ?? [];
      case "stackedbarchart":
        return uniqueColumns?.map((item) => item.columnName) ?? [];
      case "stackedbarchartimage":
        return uniqueColumns?.map((item) => item.columnName) ?? [];
      case "combochart":
        return uniqueColumns?.map((item) => item.columnName) ?? [];
      case "scatterchart":
        return Object.values(data ?? {})[0]?.map((value) => value) ?? [];
      case "treechart":

      case "radarchart":

      case "combochart":
      case "bigNumber":
      case "mapdata":
        return uniqueColumns?.map((item) => item.columnName) ?? [];
      default:
        return [];
    }
  }

  const allOptionsData = allOptions();

  useEffect(() => {
    let filterBody = null;
    if (
      ["piechart", "scatterchart", "areamap", "cordinatemap"].includes(
        VizchartType
      ) &&
      dataSourceID &&
      columnName
    ) {
      if (groupValue[0].columnType === "calculatedField") {
        filterBody = {
          databaseID: dataSourceID,
          columns: [
            {
              name: columnName,
              formula: groupValue[0].formula,
              fieldType: "calculatedField",
              dataType: groupValue[0].dataType,
            },
          ],
        };
        // http://localhost:3000/workbook?workbookid=67fcece743d18043e824a501
      } else {
        filterBody = {
          databaseID: dataSourceID,
          columns: [{ name: columnName }],
        };
      }
      if (filterBody) {
        console.log(filterBody);

        getFiltersOptions({
          filterBody: filterBody,
          calledFrom: "customColorComp",
        });
      }
    }
  }, [VizchartType, dataSourceID, columnName, getFiltersOptions]); // Ensure function is included in dependencies

  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const colorSchemeType =
    VizchartType !== "cordinatemap"
      ? customizationObject.colorSchemeType
      : "RANDOM";
  const colorSchemeid = customizationObject.colorSchemeid || "echarts4Colors";
  const COLORS = getColourSchemeByID(colorSchemeid).colors;
  const [selectedValue, setSelectedValue] = useState(null);
  console.log(COLORS);
  const [selectedColorPalette, setSelectedColorPalette] = useState(options[0]);
  const [selectedColor, setSelectedColor] = useState(null);
  // console.log(selectedColor);
  const [selectedOption, setSelectedOption] = useState(
    colorSchemeType ?? "RANDOM"
  );
  let result = Object.fromEntries(
    allOptionsData.map((key, index) => [key, COLORS[index]])
  );
  console.log(result);
  const reduxColorMapping = customizationObject.colorMapping ?? result;
  const [colorMapping, setColorMapping] = useState(reduxColorMapping);
  // console.log(colorMapping);
  useEffect(() => {
    if (!customizationObject.colorMapping && result.length > 0) {
      setColorMapping(result);
    }
  }, [customizationObject.colorMapping]);
  const handleColorSelection = (color) => {
    if (selectedValue) {
      console.log(color);
      setColorMapping((prevMapping) => ({
        ...prevMapping,
        [selectedValue]: color,
      }));
    }
    setSelectedColor(color);
  };

  const handleValueSelection = (value) => {
    setSelectedValue(value);
    setSelectedColor(colorMapping[value] || null); // Set color if already mapped
  };
  const handleApply = () => {
    if (colorMapping && selectedOption === "CUSTOM") {
      console.log(selectedOption);
      console.log(colorMapping);
      const updatedResult = { ...result, ...colorMapping };

      console.log(updatedResult);
      dispatch(
        setLevel2Properties({
          reduxKey: "colorMapping",
          Sheetid,
          parentKey: "customization",
          value: updatedResult,
          itemInArray: false,
        })
      );
      dispatch(
        setLevel2Properties({
          reduxKey: "colorSchemeType",
          Sheetid,
          parentKey: "customization",
          value: selectedOption,
          itemInArray: false,
        })
      );
    } else if (selectedOption === "RANDOM") {
      handleColorChange(selectedColorPalette);
    }
    setCustomColorModal(false);
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleApply(); // Call your function here
    }
  };

  return (
    <main
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-20"
      onKeyDown={handleKeyDown}
    >
      <main className="w-[30rem] h-96 bg-white border border-gray-400 rounded flex flex-col items-center justify-start gap-0">
        <div className="text-black w-full flex items-center justify-between p-1 font-medium bg-gray-50">
          Edit Colors[{columnName}]
          <RxCross2
            className="text-gray-600 cursor-pointer"
            onClick={() => setCustomColorModal(false)}
          />
        </div>
        {isLoading && (
          <div className="flex items-center justify-center">
            <p className="text-gray-600 font-medium">Loading filters...</p>
          </div>
        )}
        {isError && (
          <div className="flex flex-col items-center justify-center text-red-600">
            <p className="text-sm">{error?.data?.message}</p>
          </div>
        )}
        <div className="w-full flex items-center justify-start gap-1 px-1">
          <h1 className="w-auto">Color Type:</h1>
          <label className="flex items-center gap-1 justify-center cursor-pointer">
            <input
              type="radio"
              value="RANDOM"
              checked={selectedOption === "RANDOM"}
              onClick={() => {
                setSelectedOption("RANDOM");
              }}
              className="cursor-pointer"
            />
            Random
          </label>
          <label className="flex items-center gap-1 justify-center cursor-pointer">
            <input
              type="radio"
              value="CUSTOM"
              checked={selectedOption === "CUSTOM"}
              onClick={() => {
                setSelectedOption("CUSTOM");
              }}
              className="cursor-pointer"
            />
            Custom
          </label>
        </div>
        {VizchartType === "cordinatemap" ? (
          <section className="w-full pt-1 px-2 flex items-center justify-start gap-x-1 my-1">
            Field :
            <div className="w-[88%]">
              <SelectBox
                value={selectedField}
                onChange={handleValueChange}
                optionsArray={optionsArray}
              />
            </div>
          </section>
        ) : null}
        <section
          className={`w-full flex items-center justify-between gap-0 h-[75%] border-y border-gray-400 p-1`}
        >
          {selectedOption !== "RANDOM" && (
            <aside className="w-[37%] h-full border-r border-gray-400 flex flex-col items-center justify-start px-1 py-1">
              <h1 className="w-full text-left">Select Data Item :</h1>
              <div className="h-full flex flex-col w-full items-start justify-start overflow-hidden overflow-y-auto">
                {allOptionsData.map((entry, index) => (
                  <button
                    key={index}
                    onClick={() => handleValueSelection(entry)}
                    className={`rounded w-full flex items-center justify-start gap-1 text-left ${
                      selectedValue === entry ? "bg-gray-200" : ""
                    }`}
                  >
                    {console.log(entry)}
                    <span
                      className={`w-5 h-5 aspect-square rounded-sm border border-gray-300 shadow-sm`}
                      style={{
                        backgroundColor:
                          entry === selectedValue && selectedColor
                            ? selectedColor
                            : colorMapping[entry] ??
                              COLORS[index % COLORS.length],
                      }}
                    ></span>
                    {console.log(entry)}
                    <p className="truncate"> {entry}</p>
                  </button>
                ))}
              </div>
            </aside>
          )}

          <aside
            className={`${
              selectedOption === "RANDOM" ? "w-full" : "w-[63%]"
            }  h-full flex flex-col items-center justify-start p-1`}
          >
            <div className="w-full h-[90%] flex flex-col items-center justify-start">
              <CustomSelectComp
                ControllerProps={ControllerProps}
                dispatchItemToredux={dispatchItemToredux}
                colorsArray={options}
                customColorModal={customColorModal}
                selectedColorPalette={selectedColorPalette}
                setSelectedColorPalette={setSelectedColorPalette}
              />
              <div className="w-full p-2 border rounded flex flex-wrap gap-x-2 items-start justify-start h-[80%] overflow-hidden overflow-y-auto">
                {selectedColorPalette?.colors.map((item, index) => (
                  <button
                    key={index}
                    className="w-[2.35rem] h-[2.35rem]"
                    style={{ backgroundColor: item }}
                    onClick={() => handleColorSelection(item)}
                  ></button>
                ))}
              </div>
            </div>
          </aside>
        </section>
        <div className="w-full flex items-center justify-between px-1 h-[12%] bg-gray-50">
          <button
            className="border px-3"
            onClick={() => setCustomColorModal(false)}
          >
            Cancel
          </button>
          <button
            className="border bg-blue-950 text-white px-3"
            onClick={
              VizchartType !== "cordinatemap"
                ? handleApply
                : saveConditionalFormatting
            }
          >
            Apply
          </button>
        </div>
      </main>
    </main>
  );
}
